/*
  Emitted Events
    timer-started (document)
    timer-stopped (document)
*/
import { xhrRequest, createCustomEvent } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['body', 'subheader'];

  connect() {
    this.updateRunningTimer();
  }

  closePopover(event) {
    event.preventDefault()
    this.element.remove()
  }

  startOrStopTimeEntry(event) {
    event.preventDefault();
    const url = event.target.dataset.url;
    xhrRequest(url, 'post').then(({ data }) => {
      (App.afterTimeLog || []).forEach(fn => fn(data.entry));
      document.dispatchEvent(createCustomEvent(`timer-${data.running ? "started" : "stopped"}`, this.element, {}));
      this.populatePopover(data);
    }).catch(({ response }) => {
      const data = (response || {}).data || {};
      const errors = data.errors || ['There was an error updating the Time Entry'];
      this.element.prepend(this.errorDiv(errors[0]));
    });
  }

  shiftDate(event) {
    event.preventDefault();
    this.renderSpinnerInMenu();
    this.loadTimeEntriesMenu(event.target.dataset.url);
  }

  populatePopover({ listHeader, list }) {
    this.subheaderTarget.innerHTML = listHeader;
    this.bodyTarget.innerHTML = list;
  }

  errorDiv(error) {
    const newDiv = document.createElement('div');
    newDiv.className = 'text-error';
    newDiv.innerHTML = error;
    return newDiv;
  }

  renderSpinnerInMenu() {
    this.bodyTarget.innerHTML = App.spinner();
  }

  loadTimeEntriesMenu(url) {
    xhrRequest(url, 'get').then(({ data }) => this.populatePopover(data));
  }

  updateRunningTimer() {
    const timer = this.element.querySelector('.is-running-timer');
    if (timer) {
      const epoch = timer.dataset.epoch;
      let duration = moment.duration(moment().diff(moment(epoch * 1000)));
      if (duration.asHours() >= 24) {
        duration = moment.duration({ hours: 24 });
      }
      timer.innerHTML = duration.format('h:mm:ss', { trim: false });
    }
    setTimeout(this.updateRunningTimer.bind(this), 1000);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/time-entries/time-entry-menu-controller.js